<template>
  <div id="app">
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style lang="less">
@font-face {
  font-family: dinMedium;
  src: url('~@/assets/font/DINMedium.ttf');
}
.price {
  font-family: dinMedium;
}
</style>
